export default __webpack_public_path__ + "static/441-1c305a5a1dadde2ca8480d3c61500b16.gif";